import type { Kpis } from "../types";

type Props = {
  breachedNew: number;
  activeTickets: number;
};

export function TowerTilesStrip({ breachedNew, activeTickets }: Props) {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "stretch",
        borderTop: "1px solid var(--ct-line-soft)",
        borderBottom: "1px solid var(--ct-line-soft)",
        margin: "0 0 4px",
      }}
    >
      <div
        style={{
          padding: "18px 30px 18px 0",
          marginRight: 30,
          borderRight: "1px solid var(--ct-line-soft)",
          minWidth: 160,
        }}
      >
        <div
          style={{
            fontSize: 13,
            color: breachedNew > 0 ? "var(--ct-crit)" : "var(--ct-ink-3)",
            marginBottom: 4,
          }}
        >
          Breached (new)
        </div>
        <div
          className="ct-num"
          style={{
            fontSize: 30,
            fontWeight: 600,
            letterSpacing: "-0.03em",
            lineHeight: 1,
            color: breachedNew > 0 ? "var(--ct-crit)" : "var(--ct-ink-3)",
          }}
        >
          {breachedNew}
        </div>
      </div>

      <div style={{ padding: "18px 30px 18px 0", minWidth: 160 }}>
        <div
          style={{
            fontSize: 13,
            color: activeTickets > 0 ? "var(--ct-warn)" : "var(--ct-ink-3)",
            marginBottom: 4,
          }}
        >
          Active tickets
        </div>
        <div
          className="ct-num"
          style={{
            fontSize: 30,
            fontWeight: 600,
            letterSpacing: "-0.03em",
            lineHeight: 1,
            color: activeTickets > 0 ? "var(--ct-warn)" : "var(--ct-ink-3)",
          }}
        >
          {activeTickets}
        </div>
      </div>
    </div>
  );
}
